import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { CommandPalette } from './CommandPalette';
import { ToastHost } from './Toast';

export function Layout({ children }: { children: ReactNode }) {
  // Feeds the cursor position to .spot cards for the hover spotlight border.
  useEffect(() => {
    const onMove = (e: PointerEvent) => {
      const el = (e.target as HTMLElement).closest?.('.spot') as HTMLElement | null;
      if (!el) return;
      const r = el.getBoundingClientRect();
      el.style.setProperty('--mx', `${e.clientX - r.left}px`);
      el.style.setProperty('--my', `${e.clientY - r.top}px`);
    };
    window.addEventListener('pointermove', onMove);
    return () => window.removeEventListener('pointermove', onMove);
  }, []);

  return (
    <div className="app-shell" style={{ display: 'flex', minHeight: '100dvh', background: 'var(--c-bg)', position: 'relative' }}>
      <a className="skip-link" href="#main">Skip to content</a>
      <Sidebar />
      <div style={{ marginLeft: 'var(--sb-w, 220px)', flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, position: 'relative' }}>
        <div className="app-glow" aria-hidden />
        <Topbar />
        <main
          id="main"
          tabIndex={-1}
          style={{
            marginTop: '56px',
            padding: '0 var(--page-px, 32px) 48px',
            maxWidth: '2200px',
            width: '100%',
            flex: 1,
            position: 'relative',
            zIndex: 1,
          }}
        >
          {children}
        </main>
      </div>
      <CommandPalette />
      <ToastHost />
    </div>
  );
}
